import {
    JSMOverlayTemplate,
    SignupBackgroundLayout
} from "@/components/signup/layouts";
import SiteActivation, {
    ReturnToProduct
} from "@/components/signup/site-activation";
import { ServiceCollectionLogo } from "@/components/signup/utils";
import { ExperimentView, experiments } from "@/utils/experiment";

import {
    Headings,
    PickUpWhereYouLeftOffText,
    WelcomeBackText
} from "../components";

const CurrentProductUserContent = () => {
    return (
        <>
            <Headings
                main={<WelcomeBackText />}
                sub={<PickUpWhereYouLeftOffText />}
            />
            {/* everyone with a service collection should see a return to product experience */}
            <SiteActivation CurrentProductUser={<ReturnToProduct />} />
        </>
    );
};

export const CurrentProductUser = () => (
    <ExperimentView
        experiment={experiments.servCoLofiBackground}
        render={(value) =>
            value ? (
                <JSMOverlayTemplate size="sm">
                    <CurrentProductUserContent />
                </JSMOverlayTemplate>
            ) : (
                <SignupBackgroundLayout
                    ProductLogo={<ServiceCollectionLogo />}
                    theme="yellow"
                >
                    <CurrentProductUserContent />
                </SignupBackgroundLayout>
            )
        }
    />
);
